module.exports = __webpack_public_path__ + "static/media/keep-safe-tip06.0c141f1d.png";